import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * DropdownContent - A wrapper that renders a standard HTML div with Bulma class names
 *
 * This component accepts the same props as Bloomer DropdownContent for easy migration
 */
const DropdownContent = ({ className, children, style, ...props }) => {
  // Build the class names based on props
  const getClassNames = () => {
    return classNames('dropdown-menu', {
      [className]: className,
    });
  };

  return (
    <div className={getClassNames()} style={style} {...props}>
      <div className="dropdown-content">
        {children}
      </div>
    </div>
  );
};

DropdownContent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};

DropdownContent.defaultProps = {
  className: '',
  style: {},
  children: null,
};

export default DropdownContent;
